import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { ThisAccount } from "../../redux/Account/account.selectors";
import { switchAccount } from "../../redux/Auth/auth.actions";
import { Me } from "../../redux/Auth/auth.selectors";
import { SmartContainer, Stack } from "../../styles/Containers";
import { StyledModal } from "../../styles/matieralui/Modal";
import { StyledP } from "../../styles/StyledHTML";
import { FormSelect } from "../Forms/FormSelect";
import { NewAccountForm } from "./NewAccountForm";
import { Theme } from "../../styles/Theme";

const StyledSwitcher = styled(SmartContainer)`
    margin-top: 0.5em;
    /* border-top: 1px solid rgba(0,0,0,0.15) !important;
    border-bottom: 1px solid rgba(0,0,0,0.15) !important; */
    /* border-top: ${Theme.borderWidth} solid ${Theme.colors.dark}; */
    /* border-bottom: ${Theme.borderWidth} solid ${Theme.colors.dark}; */
    /* padding-top: 0.5em; */
    padding-bottom: 0.5em;

    fieldset {
        border: 0px;
    }
    select {
        /* padding-top: 0px;
        padding-bottom: 0px; */
        color: rgba(0,0,0,0.5);
        border:0px !important;
    }
    .MuiOutlinedInput-notchedOutline {
        border:0px !important;
    }

`


export const AccountSwitcher = () => {
    const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const dispatch = useDispatch();
    const me = Me();
    const thisAccount = ThisAccount();
    const handleChange = (v) => {
        if (v === 'new') setOpenModal(true)
        else if (thisAccount.id !== v) dispatch(switchAccount(v))
        return;
    }
    const handleCloseModal = () => setOpenModal(false)
    const accounts = me?.accounts;

    return (
        <StyledSwitcher clickable>
            <FormSelect value={thisAccount.id} onChange={handleChange}>
                {accounts?.map(account => {
                    return (<option key={account.id} value={account.id}>{account.name}</option>)
                })}
                <option key="new" value="new">Create Another Account</option>
            </FormSelect>
            <StyledModal
                open={openModal}
                onClose={handleCloseModal}
                label="Create a new account for yourself"
                description="Create a completely new account"
            >
                <Stack>
                    <StyledP>This is a completely separately billed account.</StyledP>
                    <NewAccountForm />
                </Stack>

            </StyledModal>
        </StyledSwitcher>
    )
}